export default {

  data() {
    return {
      map: null,
      layer: null,
    };
  },

  computed: {

    tagName() {
      return this.$vnode.tag.split('-').pop();
    }

  },

  methods: {

    handleLayerReady(layer) {
      // console.log(`handleLayerReady:${this.tagName}`);
      this.layer = layer;
      this.$emit('layer-ready', layer);
    },

    fitLayerBounds(pad = null) {
      // console.log(`fitLayerBounds:${this.tagName}`);
      // console.warn('fitLayerBounds');
      if (this.layer) {
        if (this.layer._map) {
          const bounds = this.layer.getBounds();
          if (bounds.isValid()) {
            this.$nextTick(() => {
              // console.log('next tick');
              this.layer._map.fitBounds(bounds.pad(pad));
            });
          }
        }
      }
    },

  },

};
